export var GamespaceSettingsPath;
(function (GamespaceSettingsPath) {
    GamespaceSettingsPath["LEADERBOARDS"] = "leaderboards";
    GamespaceSettingsPath["STORE"] = "store";
    GamespaceSettingsPath["ADVANCED"] = "advanced";
})(GamespaceSettingsPath || (GamespaceSettingsPath = {}));
